import { addDays, formatIsoDate } from 'lib/datetime/dateUtils'
import type { OfferDurationOption } from 'lib/offer/offerDurationTypes'

export function buildPropertyDurationOptions(
  durationOptions: Array<App.Property.DurationOption> | undefined,
  checkIn?: string,
): Array<OfferDurationOption> {
  if (!durationOptions) return []

  const checkInDate = checkIn ? new Date(checkIn) : undefined

  return durationOptions.map(({ duration, hasBonusInclusions, hasTactical, promotion }) => {
    const expectedCheckOut = checkInDate ? formatIsoDate(addDays(checkInDate, duration)) : undefined
    const satisfiesPromotionTravelSchedule = (
      !!promotion &&
      (!checkIn || checkIn >= promotion.travelFromIsoDate) &&
      (!expectedCheckOut || expectedCheckOut <= promotion.travelToIsoDate)
    )

    return {
      duration,
      hasExclusive: satisfiesPromotionTravelSchedule && promotion.type === 'campaign',
      hasPromotion: satisfiesPromotionTravelSchedule,
      hasBonusInclusions,
      hasTactical,
    }
  })
}

export function shouldShowPropertyDurationTabs(
  durationOptions: ReadonlyArray<OfferDurationOption>,
): boolean {
  return durationOptions.some(option => !!(
    option.hasBonusInclusions ||
    option.hasTactical ||
    option.hasPromotion
  ))
}
